import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { List, ListItemButton, Typography } from '@mui/material';
// components
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

ServiceList.propTypes = {
  services: PropTypes.array,
  onItemClick: PropTypes.func,
  grid: PropTypes.bool,
  sx: PropTypes.object,
};

export default function ServiceList({ services = [], onItemClick, grid = false, sx, ...other }) {
  return (
    <List
      disablePadding
      sx={{
        width: '100%',
        ...(grid && {
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          columnGap: 3,
          rowGap: 1.5,
        }),
        ...sx,
      }}
      {...other}
    >
      {services.map((service, index) => {
        const { id, slug, title } = service;

        return (
          <ListItemButton
            key={id || slug || index}
            component={RouterLink}
            to={`/service/${slug}`}
            onClick={onItemClick}
            sx={{
              gap: 1.5,
              mb: grid ? 0 : 1,
              px: 2,
              py: 1.25,
              borderRadius: 1.5,
              border: (theme) => `1px solid ${theme.palette.divider}`,
              transition: (theme) => theme.transitions.create(['background-color', 'border-color', 'padding-left']),
              '&:hover': {
                pl: 2.5,
                borderColor: 'primary.main',
                bgcolor: 'background.neutral',
              },
            }}
          >
            <Iconify icon="eva:briefcase-outline" width={20} sx={{ flexShrink: 0, color: '#DF3E30' }} />

            <Typography variant="subtitle1" sx={{ flexGrow: 1, minWidth: 0, color: '#000' }}>
              {title}
            </Typography>

            <Iconify icon="eva:arrow-ios-forward-fill" width={18} sx={{ flexShrink: 0, color: 'text.disabled' }} />
          </ListItemButton>
        );
      })}
    </List>
  );
}
